import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    display: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {};
  },
});
